@if (!isResetPasswordEmailSent) {
    <h3>{{ 'forgotPassword.receiveResetLink' | translate }}</h3>
} @else {
    <h3>{{ 'forgotPassword.resetLinkSent' | translate }}</h3>
    <h3>{{ 'forgotPassword.clickLinkInEmail' | translate }}</h3>
}
<div class="content">
    <form action="" method="post" [formGroup]="forgotPasswordForm">
        @if (!isResetPasswordEmailSent) {
            <div class="inputGroup">
                <label for="email">{{ 'forgotPassword.emailAddress' | translate }}</label>
                @if (forgotPasswordForm.get('email')?.touched && forgotPasswordForm.get('email')?.invalid) {
                    <app-form-error [parentForm]="forgotPasswordForm" [controlPath]="'email'" />
                }
                <div class="inputWrapper">
                    <i class="icon inputIcon prefix fal fa-sx fa-fw fa-user" aria-hidden="true"></i>
                    <input type="email" autocomplete="email" id="email" [formControlName]="'email'" />
                </div>
            </div>
        }
        <div class="buttonArea">
            @if (!isResetPasswordEmailSent) {
                <button
                    class="button primary"
                    type="submit"
                    id="recoverPassword"
                    [title]="'forgotPassword.recoverPassword' | translate"
                    (click)="recoverPassword()"
                >
                    {{ 'forgotPassword.recoverPassword' | translate }}
                </button>
            }

            @if (isResetPasswordEmailSent) {
                <button
                    class="button secondary"
                    type="submit"
                    id="resendEmail"
                    [title]="'forgotPassword.resendEmail' | translate"
                    (click)="recoverPassword()"
                >
                    {{ 'forgotPassword.resendEmail' | translate }}
                </button>
            }
        </div>
        <div class="linkContainer center">
            <a routerLink="/login">{{ 'forgotPassword.signIn' | translate }}</a>
        </div>
    </form>
</div>
